module.exports = __webpack_public_path__ + "img/d6de4de.jpg";